<div class="error-guide-page-{{appName}}" id="error-guide-page">
    <div class="row" *ngIf="showAdd">
        <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15 ml-3 mr-3 mt-3">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>
    <div class="row error-guide-header" [hidden]="windowWidth<=1024">
        <div class="col-12">
            <span>
                <label style="line-height: 70px;" *ngIf="portalName== 'Toyota'" class="error-label">{{"Label.error_guide_title" | translate}}</label>

                <label style="line-height: 70px;" *ngIf="portalName== 'Lexus'" class="error-label">{{"Label.lexus_error_guide_title" | translate}}</label>
            </span>
            <span class="float-right ml-auto d-flex align-items-center">

                <span>
                    <mat-form-field class="error-group-header error-label mr-2 ">
                        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
                    </mat-form-field>
                </span>
                <span>
                    <mat-radio-group ngDefaultControl class="error-group-header">
                        <mat-radio-button ngDefaultControl (change)="onPlatformChange($event)" labelPosition="before" *ngFor="let option of errorGuideOptions"
                            [checked]="option.checked" [value]="option.value">{{option.name}}</mat-radio-button>
                    </mat-radio-group>
                </span>


                <span style="margin-right: 15px;">
                    <mat-select #errorSelect id="{{appName}}-error-guide-select" disableOptionCentering panelClass="errorGuideClass" class="btn btn-default ml-4 error-columns"
                        (selectionChange)="onColumnChange();" [(ngModel)]="displayedColumns" multiple placeholder="Select Columns">
                        <mat-select-trigger>
                            Select Columns
                        </mat-select-trigger>
                        <mat-option [hidden]="appName !== 'admin'" id="{{appName}}-{{messageAppName}}-error-guide-options" *ngFor="let column of columns"
                            [value]="column.name">{{column.value}}</mat-option>

                        <mat-option [hidden]="appName === 'admin'" id="{{appName}}-error-guide-options" *ngFor="let column of columns" [value]="column.name">{{column.value}}</mat-option>
                    </mat-select>
                </span>
                <span [hidden]="appName === 'admin'">
                    <a placeholder="Close Message Guide">
                        <span (click)="closeErrorGuide()" class="fa fa-times close-btn cursor-pointer" aria-hidden="true"></span>
                    </a>
                </span>
            </span>
        </div>
    </div>
    <div class="row" *ngIf="showAdd">
        <span class="float-right ml-auto" style="margin-right:40px;">
            <input #templateUploader id="templateUploader" class="templateUploader" type="file" (click)="templateUploader.value=null"
                hidden name="avatar" (change)="onFileChange($event,$event.target.files)" />
            <button class="col-5 mb-2 btn btn-browse" style="min-width:175px;" type="button" (click)="uploadFiles()">{{ "Button.upload_message_guide" | translate}}</button>
            <button *ngIf="showAdd" class="ml-4 mb-2  btn btn-default" style="min-width:175px;" type="button" [routerLink]="'/admin/add-message-guide'">Add Message Guide</button>

        </span>
    </div>
    <div class="row error-table-block" [hidden]="windowWidth<=1024">
        <div class="col-md-12 error-guide-table">

            <table aria-describedby="message" aria-labelledby="message" mat-table [dataSource]="errorGuidesDataSource" matSort class="col-md-12 error-guides-table mat-elevation-z8">

                <ng-container matColumnDef="code" sticky>
                    <th id="message-code" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Support Code </th>
                    <td mat-cell *matCellDef="let element"> {{element.code ? element.code : ''}} </td>
                </ng-container>

                <ng-container matColumnDef="feature">
                    <th id="message-feature" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Feature </th>
                    <td mat-cell *matCellDef="let element"> {{element.feature ? element.feature :''}} </td>
                </ng-container>

                <ng-container matColumnDef="message.solution">
                    <th id="message-solution" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Solution </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.solution ? element.message.solution :''}} </td>
                </ng-container>

                <ng-container matColumnDef="message.contentTCI">
                    <th id="message-contentTCI" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Content TCI </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.contentTCI !== null || element.message.contentTCI !== undefined ? element.message.contentTCI
                        : ''}} </td>
                </ng-container>

                <ng-container matColumnDef="message.effect">
                    <th id="message-effect" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Effect </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.effect ? element.message.effect: ''}} </td>
                </ng-container>

                <ng-container matColumnDef="message.contentTMNA">
                    <th id="message-contentTMNA" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Content TMNA </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.contentTMNA ? element.message.contentTMNA :'' }} </td>
                </ng-container>

                <ng-container matColumnDef="message.description">
                    <th id="message-desc" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.description ? element.message.description:''}} </td>
                </ng-container>

                <ng-container matColumnDef="message.cause">
                    <th id="message-cause" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Cause </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.cause ? element.message.cause :''}} </td>
                </ng-container>

                <ng-container matColumnDef="message.shortDescription">
                    <th id="message-shortDesc" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Short Description </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.shortDescription ? element.message.shortDescription :''}} </td>
                </ng-container>

                <ng-container matColumnDef="message.diagnostic">
                    <th id="message-diagnostic" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Diagnostic </th>
                    <td mat-cell *matCellDef="let element"> {{element.message.diagnostic ? element.message.diagnostic : ''}} </td>
                </ng-container>

                <ng-container matColumnDef="tdPR_SP">
                    <th id="message-tdpr" class="resource-header-card" [hidden]="appName && appName !== 'admin'" mat-header-cell *matHeaderCellDef
                        mat-sort-header>
                        TDPR SP </th>
                    <td [hidden]="appName && appName !== 'admin'" mat-cell *matCellDef="let element"> {{element.tdPR_SP ? element.tdPR_SP : ''}} </td>
                </ng-container>

                <ng-container matColumnDef="updatedBy">
                    <th id="message-updatedBy" class="resource-header-card" [hidden]="appName && appName !== 'admin'" mat-header-cell *matHeaderCellDef
                        mat-sort-header>
                        Updated By </th>
                    <td mat-cell [hidden]="appName && appName !== 'admin'" *matCellDef="let element"> {{element.updatedBy ? element.updatedBy: ''}} </td>
                </ng-container>

                <ng-container matColumnDef="updatedAt">
                    <th id="message-updatedAt" class="resource-header-card" [hidden]="appName && appName !== 'admin'" mat-header-cell *matHeaderCellDef
                        mat-sort-header>
                        Updated At </th>
                    <td mat-cell [hidden]="appName && appName !== 'admin'" *matCellDef="let element"> {{element.updatedAt | date:'MM/dd/yy, hh:mm a'}} </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th id="message-action" [hidden]="appName && appName !== 'admin'" class="resource-header-card" mat-header-cell *matHeaderCellDef>Actions</th>
                    <td [hidden]="appName && appName !== 'admin'" mat-cell *matCellDef="let row">
                        <span class="action-control col-md-1">
                            <a matTooltip="Click to Edit" class="action-control-delete" (click)="editErrorGuide(row);">
                                <img alt="Edit" [src]="commonService.commonFiles['edit']">
                            </a>
                        </span>
                        <span class="action-control col-md-1 ml-2">
                            <a matTooltip="Click to Delete" class="action-control-delete" (click)="deleteErrorGuide(row);">
                                <img alt="Delete" [src]="commonService.commonFiles['delete']">
                            </a>
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>

    </div>
    <div class="row col-12 error-paginator" [hidden]="windowWidth <= 1024">
        <mat-paginator [pageSizeOptions]="[5,10,20,50]" showFirstLastButtons></mat-paginator>
    </div>

    <div [hidden]="windowWidth > 1024" class="col-12 responsive-message-guide p-0 m-0">
        <div class="col-12">
            <span class="row">
                <span class="col-12">
                    <label style="line-height: 70px;" *ngIf="portalName== 'Toyota'" class="error-label">{{"Label.error_guide_title" | translate}}</label>
                    <label style="line-height: 70px;" *ngIf="portalName== 'Lexus'" class="error-label">{{"Label.lexus_error_guide_title" | translate}}</label>
                    <i (click)="goBack();" class="fa fa-arrow-circle-o-left message-back-icon" aria-hidden="true"></i>
                </span>
            </span>
            <span class="row col-12 align-items-center">
                <span>
                    <mat-radio-group ngDefaultControl class="error-group-header">
                        <mat-radio-button ngDefaultControl (change)="onPlatformChange($event)" labelPosition="before" *ngFor="let option of errorGuideOptions"
                            [checked]="option.checked" [value]="option.value">{{option.name}}</mat-radio-button>
                    </mat-radio-group>
                </span>
            </span>
        </div>
        <mat-accordion class="col-12 example-headers-align">
            <mat-expansion-panel class="responsive-mat-panel" *ngFor="let ds of messageGuideData;let dIndex=index;">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ds.code}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <div class="row col-12 m-0 p-0">
                        <th id="message-guide-header" style="display:none;">Message Guide</th>
                        <table aria-labelledby="message" aria-describedby="message" class="col-12 guide-content-table">
                            <th id="message-guide-headere" style="display:none;">Message Guide</th>
                            <tr *ngFor="let cols of responsiveColumns;let i=index;" class="guide-content-table-row">
                                <td>
                                    <div class="responsive-feature-description col-12" style="display:flex;padding-right: 0;padding-left: 0;">
                                        <div class="col-5 p-0 message-guide-column">
                                            <div class="col p-0 responsive-feature-title-column">
                                                <div class="message-guide-header-column">{{cols.value}}</div>
                                            </div>
                                        </div>
                                        <div class="col-7 message-guide-content-column">
                                            {{ds[cols.name]}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </ng-template>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>